// src/main.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/styles/main.css'
import './assets/styles/global.css'

// Import axios instance (sudah ada interceptor 401)
import './utils/axios'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)

app.use(pinia)
app.use(router)

app.mount('#app')

// ========== TOKEN EXPIRY CHECKER - SETIAP 1 JAM ==========
let tokenCheckInterval = null
const CHECK_INTERVAL_MS = 60 * 60 * 1000 // 1 jam = 3600000 ms

function startTokenCheck() {
  if (tokenCheckInterval) clearInterval(tokenCheckInterval)
  
  // Check sekali saat startup
  checkTokenNow()
  
  // Set interval setiap 1 jam
  tokenCheckInterval = setInterval(() => {
    checkTokenNow()
  }, CHECK_INTERVAL_MS)
  
  console.log('✅ Token expiry checker started (checking every 1 hour)')
}

function checkTokenNow() {
  // Import dynamically to avoid circular dependency
  import('./stores/auth').then(({ useAuthStore }) => {
    const authStore = useAuthStore()
    if (authStore.isAuthenticated && authStore.checkTokenAndLogout) {
      authStore.checkTokenAndLogout()
    }
  }).catch(() => {
    // Fallback: check localStorage directly jika import gagal
    const token = localStorage.getItem('token')
    if (token) {
      try {
        const parts = token.split('.')
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]))
          if (payload.exp && Date.now() >= payload.exp * 1000) {
            console.log('⏰ Token expired (fallback check), logging out...')
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('user_source')
            localStorage.removeItem('user_location')
            localStorage.removeItem('user_source_name')
            if (window.location.pathname !== '/login') {
              window.location.href = '/login'
            }
          }
        }
      } catch (e) {
        console.error('Fallback token check error:', e)
      }
    }
  })
}

function stopTokenCheck() {
  if (tokenCheckInterval) {
    clearInterval(tokenCheckInterval)
    tokenCheckInterval = null
    console.log('✅ Token expiry checker stopped')
  }
}

// Start checking after app is ready
setTimeout(startTokenCheck, 2000)

// Stop on page unload
window.addEventListener('beforeunload', stopTokenCheck)

// Handle visibility change (tab aktif/tidak aktif)
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    // Tab menjadi aktif, check token sekarang
    checkTokenNow()
  }
})